import React from "react";

export default function EmployerStatusBand({
  kicker = "Arbeitsstand",
  title,
  note,
  items = [],
  actions = null,
  className = "",
}) {
  return (
    <section className={`employer-status-band ${className}`.trim()}>
      {(kicker || title || note || actions) ? (
        <div className="employer-status-band__top">
          <div className="employer-status-band__copy">
            {kicker ? <span className="employer-status-band__kicker">{kicker}</span> : null}
            {title ? <h2>{title}</h2> : null}
            {note ? <p>{note}</p> : null}
          </div>
          {actions ? <div className="employer-status-band__actions">{actions}</div> : null}
        </div>
      ) : null}

      {items.length ? (
        <div className="employer-status-band__grid">
          {items.map((item, index) => (
            <article
              key={item.key || item.label || index}
              className={`employer-status-band__item${item.tone ? ` is-${item.tone}` : ""}`}
            >
              <span className="employer-status-band__label">{item.label}</span>
              <strong className="employer-status-band__value">{item.value}</strong>
              {item.note ? <p className="employer-status-band__note">{item.note}</p> : null}
            </article>
          ))}
        </div>
      ) : null}
    </section>
  );
}
